import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const roreTechCostsRoutes = [
  {
    path: 'techcosts',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.trc('rore', 'Tech costs')
      },
      permissions: ['READ_RORE_TECH_COSTS']
    },
    children: [
      {
        path: '',
        name: 'roreTechCostsList',
        component: wrapLegacyRoute('roreTechCostsController', 'list')
      },
      {
        path: 'create',
        name: 'roreTechCostCreate',
        component: wrapLegacyRoute('roreTechCostsController', 'create')
      },
      {
        path: ':techCostId(\\d+)',
        name: 'roreTechCostDetails',
        component: wrapLegacyRoute('roreTechCostsController', 'details')
      }
    ]
  }
];

export default roreTechCostsRoutes;
